import CardList, { CardListProps } from './CardList';

export type { CardListProps };
export default CardList;
